const SearchSpinner = ({ enterPressed }: { enterPressed: boolean }) => {
  return (
    <div
      id="search-spinner"
      className={`animate-spin rounded-full mt-2 h-6 w-6 ${
        enterPressed ? 'border-t-2 border-b-2 border-gray-400 dark:border-gray-300 absolute right-2 md:right-2.5' : 'hidden'
      }`}
    />
  );
};
export { SearchSpinner };
